import React from "react";
import PropTypes from "prop-types";
import { getNairaFormat } from "../../../utils/Utils";
import { FaSave, FaRegEdit, FaTimes } from "react-icons/fa";
import { CustomSmallBtn } from "../Lease.styled";

export const AssetRegistrationSideBar = ({
	leaseData,
	toggleEdit,
	setToggleEdit,
	handleCancel,
	isEditable,
	isInsurance,
}) => {
	return (
		<div className='LeftSection'>
			<SideBar leaseData={leaseData} />
			{isEditable && (
				<>
					{!toggleEdit ? (
						<CustomSmallBtn
							type='button'
							onClick={() => setToggleEdit(true)}
							style={{ background: "white", color: "#006770" }}>
							<FaRegEdit size={16} />
							<span>Edit Details</span>
						</CustomSmallBtn>
					) : (
						<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
							<CustomSmallBtn type='submit' style={{ background: "#006670", color: "white" }}>
								{isInsurance ? (
									"Apply for Insurance"
								) : (
									<>
										<FaSave size={17} />
										<span>Save Details</span>
									</>
								)}
							</CustomSmallBtn>
							<CustomSmallBtn
								type='button'
								style={{ background: "white", color: "red", borderColor: "red" }}
								onClick={handleCancel}>
								<FaTimes size={16} />
								<span>Cancel</span>
							</CustomSmallBtn>
						</div>
					)}
				</>
			)}
		</div>
	);
};

const SideBar = ({ leaseData }) => {
	return (
		<div className='productDetails'>
			<img src={leaseData?.image || "/images/placeholder_img.jpg"} alt='product' />
			<h6>{leaseData?.productName || leaseData?.productId?.productName || "---"}</h6>
			<p>{getNairaFormat(leaseData?.amount)}</p>
		</div>
	);
};

AssetRegistrationSideBar.propTypes = {
	leaseData: PropTypes.object,
	toggleEdit: PropTypes.bool,
	isEditable: PropTypes.bool,
	setToggleEdit: PropTypes.func,
	handleCancel: PropTypes.func,
	isInsurance: PropTypes.bool,
};

SideBar.propTypes = {
	leaseData: PropTypes.object,
};
